import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { Dispatch } from 'redux';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';
import { uploadFilesSet } from '@synergy/data-access';

import { Api } from '../../../../../../api';
import { AppState } from '../../../../../../store/models/app-state';
import { DemandAccountFeedbackFormValues } from '../../pages/feedback-detail/feedback-detail-form-modal';
import { DemandAccountFeedbackRequest } from '../../models/feedback-request';
import { FeedbackFormValues } from '../../models/feedback-form-values';
import { StepData } from '../../../../../../common/components/new-stepper/step-data';

export const DEMAND_DETAIL_FEEDBACK_SUBMIT = 'DEMAND_DETAIL_FEEDBACK_SUBMIT';
export const DEMAND_DETAIL_FEEDBACK_UPDATE = 'DEMAND_DETAIL_FEEDBACK_UPDATE';
export const DEMAND_DETAIL_FEEDBACK_DETAIL_RECEIVED = 'DEMAND_DETAIL_FEEDBACK_DETAIL_RECEIVED';
export const DEMAND_DETAIL_FEEDBACK_RECEIVED = 'DEMAND_DETAIL_FEEDBACK_RECEIVED';
export const DEMAND_DETAIL_FEEDBACK_DECLINED = 'DEMAND_DETAIL_FEEDBACK_DECLINED';

export const submitFeedback = (data: StepData<FeedbackFormValues>) => ({
    type: DEMAND_DETAIL_FEEDBACK_SUBMIT,
    data,
});

export const decline = (ids: number[], reason?: string) => {
    return async (dispatch: Dispatch, getState: () => AppState, { api }: { api: Api }) => {
        const demandId = getState().demandDetail.overview.stepData.values.id;

        if (demandId === undefined) {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.demandSavedError')));
            return;
        }

        const response = await api.demands.decline(demandId, ids, reason);
        if (response.success) {
            dispatch({ type: DEMAND_DETAIL_FEEDBACK_DECLINED, ids, reason });
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const sendInfoMail = (demandId: number, demandAccountId: number) => {
    return async (dispatch: Dispatch, _: () => AppState, { api }: { api: Api }) => {
        const response = await api.demands.sendInfoMail(demandId, demandAccountId);

        if (response.success) {
            dispatch(Snackbar.enqueue(PoolNotification.success('app.demands.detail.feedback.sendInfoMail.snackbar')));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const fetchFeedbackDetail = (id: number) => {
    return async (dispatch: Dispatch, getState: () => AppState, { api }: { api: Api }) => {
        const demandId = getState().demandDetail.overview.stepData.values.id;

        if (demandId === undefined) {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.demandSavedError')));
            return;
        }

        const response = await api.demands.getFeedback(demandId, id);

        if (response.success) {
            dispatch(uploadFilesSet(response.result.media));
            dispatch({ type: DEMAND_DETAIL_FEEDBACK_DETAIL_RECEIVED, feedback: response.result });
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const updateFeedback = (id: number, feedback: DemandAccountFeedbackFormValues) => {
    return async (dispatch: Dispatch, getState: () => AppState, { api }: { api: Api }) => {
        const demandId = getState().demandDetail.overview.stepData.values.id;

        if (demandId === undefined) {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.demandSavedError')));
            return;
        }

        const request: DemandAccountFeedbackRequest = {
            items: feedback.items.map(item => ({
                demandItemId: item.demandItemId,
                quantity: item.quantity,
                deliveryAddressId: item.deliveryAddress.id,
                id: item.id,
                costCentre: item.costCentre,
            })),
            internalNote: feedback.internalNote,
        };

        const response = await api.demands.updateFeedback(demandId, id, request);
        if (response.success) {
            dispatch({ type: DEMAND_DETAIL_FEEDBACK_UPDATE, feedback: response.result });
            dispatch(Snackbar.enqueue(PoolNotification.success('app.snackbar.saved')));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};
